export const RavenService = Symbol('RavenService');

export interface TrackEventPayload {
    /**
     * 事件名字
     */
    sourceType: string;
    /**
     * 事件的模块名
     */
    eventType: string;
    /**
     * 一般是taskId之类的唯一标识
     */
    otherParam?: string;
    /**
     * 其他埋点参数
     */
    eventDetailStr?: Record<string, unknown>;
}

export interface RavenService {
    /**
     * 跟踪事件
     * @param eventCode 事件名称
     * @param data 埋点数据
     */
    track(eventCode: string, data: Partial<TrackEventPayload>): Promise<void>;
}
